import { Snackbar, } from "@mui/material";
import React, { Dispatch, SetStateAction } from "react";
import { SnackbarState } from "../interfaces/SnackbarState";
import SnackbarMessage from "../../../theme/extensions/SnackbarMessage";

export default function SnackbarGroup({ setSnackbars, snackbars }: {
  setSnackbars: Dispatch<SetStateAction<SnackbarState[]>>
  snackbars: SnackbarState[];
}) {

  const handleCloseSnackbar = (key: number) => {
    setSnackbars((prev) =>
      prev.filter((snackbar) => snackbar.key !== key)
    );
  };

  return (
    <>
      {snackbars?.map((snackbar, idx) => (
        <Snackbar
          key={snackbar.key}
          open={true}
          autoHideDuration={6000}
          onClose={() => handleCloseSnackbar(snackbar.key)}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          style={{ marginTop: idx * 60 }}
        >
          <SnackbarMessage
            variant={snackbar.severity}
            message={snackbar.message}
          />
        </Snackbar>
      ))}
    </>
  );
}
